import { render, staticRenderFns } from "./feefo-mini.vue?vue&type=template&id=151856d3&scoped=true&lang=pug&"
import script from "./feefo-mini.vue?vue&type=script&lang=js&"
export * from "./feefo-mini.vue?vue&type=script&lang=js&"
import style0 from "./feefo-mini.vue?vue&type=style&index=0&id=151856d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151856d3",
  null
  
)

/* custom blocks */
import block0 from "./feefo-mini.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteFeefoStars: require('/home/ubuntu/nuxt/bonkers/releases/20230322165259/components/site/feefo-stars.vue').default})
